<template>
  <TransitionRoot :show="open" as="template">
    <Dialog as="div" class="relative z-50" @close="$emit('close')">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-md transform overflow-hidden rounded-lg bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl transition-all"
            >
              <div class="flex items-center gap-3 mb-4">
                <div
                  class="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/50 flex items-center justify-center"
                >
                  <ExclamationTriangleIcon class="h-5 w-5 text-red-600 dark:text-red-400" />
                </div>
                <DialogTitle
                  as="h3"
                  class="text-lg font-medium leading-6 text-gray-900 dark:text-white"
                >
                  {{ clearAllMode ? 'Alle Gegevens Wissen' : `${table?.label} Wissen` }}
                </DialogTitle>
              </div>

              <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">
                <template v-if="clearAllMode">
                  Weet je zeker dat je
                  <strong class="text-gray-700 dark:text-gray-200">alle gegevens</strong> wilt
                  wissen? Dit omvat medewerkers, uren, prospects, toewijzingen en alle gerelateerde
                  data.
                </template>
                <template v-else>
                  Weet je zeker dat je alle
                  <strong class="text-gray-700 dark:text-gray-200">{{ recordCount }}</strong>
                  records uit
                  <strong class="text-gray-700 dark:text-gray-200">{{ table?.label }}</strong> wilt
                  wissen?
                  <span
                    v-if="table?.cascadeWarning"
                    class="block mt-2 text-red-600 dark:text-red-400"
                  >
                    {{ table.cascadeWarning }}
                  </span>
                </template>
              </p>

              <p class="text-sm text-red-600 dark:text-red-400 font-medium mb-4">
                Deze actie kan niet ongedaan worden gemaakt!
              </p>

              <div class="flex justify-end gap-3">
                <button
                  type="button"
                  @click="$emit('close')"
                  class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600"
                >
                  Annuleren
                </button>
                <button
                  type="button"
                  @click="$emit('confirm')"
                  :disabled="isClearing"
                  class="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:bg-red-400"
                >
                  {{ isClearing ? 'Bezig...' : 'Wissen' }}
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionRoot, TransitionChild } from '@headlessui/vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'

defineProps({
  open: {
    type: Boolean,
    required: true
  },
  table: {
    type: Object,
    default: null
  },
  recordCount: {
    type: Number,
    default: 0
  },
  clearAllMode: {
    type: Boolean,
    default: false
  },
  isClearing: {
    type: Boolean,
    default: false
  }
})

defineEmits(['close', 'confirm'])
</script>
